//
// Adapted from MentalCanvas C++ code.
// (c) 2016-2020 Mental Canvas Inc.

import {
    Vector2
} from 'three';
import {
    _Math
} from './utils';

export class ManipDelta {
    constructor(InAngleRad: number, InOrigin: Vector2, InTranslation: Vector2, InScale: number)
    {
        this.m_AngleRad = InAngleRad;
        this.m_Origin = InOrigin.clone();
        this.m_Translation = InTranslation.clone();
        this.m_Scale = InScale;
    }
    GetAngleRad() : number {
        return this.m_AngleRad;
    }
    GetOrigin() : Vector2 {
        return this.m_Origin;
    }
    GetTranslation() : Vector2 {
        return this.m_Translation;
    }
    GetScale() : number {
        return this.m_Scale;
    }
    private m_Origin = new Vector2(0, 0);
    private m_AngleRad : number = 0;
    private m_Translation = new Vector2(0, 0);
    private m_Scale : number = 1;
};

export enum ManipEventType {
    ET_Undefined = 0,
    ET_Starting,
    ET_Started,
    ET_Moving,
    ET_Completed,
    ET_NUM
}

export enum DrawableToolEventResponse {
    ER_ConsumeEvent, // Consume event, do not allow later tools on the stack to receive the event 
    ER_ChainEvent    // Allow other tools on the stack to receive the event
}

export class DrawableTool {
    constructor(InViewportDims: Vector2) {
        this.m_ViewportDims = InViewportDims;
    }
    dispose() {}
    // Pointer to *shared* viewport dims. May be updated by caller at any time.
    protected m_ViewportDims: Vector2;
}

export class ManipEvent {
    constructor(time: number, type: ManipEventType, position: Vector2, manipDelta: ManipDelta = null, bInertial: boolean = false, bSpoofed: boolean = false)
    {
        this.m_TimeUSecs = time;
        this.m_Type = type;
        this.m_Position = position;
        this.m_ManipDelta = manipDelta;
        this.m_bIsInertial = bInertial;
        this.m_bIsSpoofed = bSpoofed;
    }
    GetType():ManipEventType {
        return this.m_Type;
    }
    HasDelta(): boolean {
        return this.m_ManipDelta != null;
    }
    GetDelta(): ManipDelta {
        return this.m_ManipDelta;
    }
    IsSpoofed(): boolean {
        return this.m_bIsSpoofed;
    }

    private m_TimeUSecs : number; // Relative to app start. TODO: need uint64
	private m_Type : ManipEventType;
	private m_Position : Vector2;
	private m_ManipDelta : ManipDelta;
	private m_bIsInertial : boolean; 
	private m_bIsSpoofed : boolean; // not a "real" manip event (from touch) - it's spoofed from mouse buttons / wheel / etc.
};